// Presentation metadata only: menu authorization and route behavior stay in the router/store.
const customerPages = ['home', 'club-list', 'subscriptions', 'customer-detail', 'customer-users', 'customer-followups', 'customer-feedback', 'customer-analytics', 'customer-classification'];
const formPages = ['admin-config', 'officialweb-config', 'minipro-config', 'officialaccount-config', 'application-config', 'customer-config', 'order-config', 'send_mp_template', 'adsense-limit', 'edit-unit', 'roleEdit', 'customerEdit', 'modify'];
const analysisPages = ['dataSummarize', 'trafficAnalysis', 'tradeAnalysis', 'serviceAnalysis', 'userAnalysis'];
const localHeadingPages = ['staff', 'role', 'customerService', 'whitelist', 'app-banner', 'articles', 'vip-type', 'vip-order', 'adsense-icon', 'adsense-badge', 'account-list', 'work-log', 'menulist', 'customer-orders', 'customer-cash', 'face-manage'];
const pageTitles: {[key: string]: string} = {
    'adsense-page': '店铺产品', 'adsense-url': '店铺链接', 'adsense-kf': '店铺客服',
    'adsense-banner': '店铺轮播管理', 'adsense-log': '店铺操作日志', 'adsense-icon': '快捷图标',
    'adsense-badge': '角标设置',
    'adsense-limit': '默认额度', 'vip-order': '开通与续费记录', 'account-list': '报账管理',
    'stafflog': '员工操作日志', 'apiAbnormal': '接口异常', 'app-banner': 'APP轮播图',
    'send_mp_template': '发送模板消息', 'modify': '编辑文章', 'category': '帮助分类管理',
};

export function pageLayout(path: string, title: string) {
    const key = path.replace(/^\//, '');
    return {
        key,
        title: pageTitles[key] || title,
        ownHeading: key === 'tutorials' || customerPages.includes(key) || localHeadingPages.includes(key),
        mode: formPages.includes(key) ? 'form' : analysisPages.includes(key) ? 'analysis' : key === 'chatroom' ? 'chat' : key === 'userinfo' ? 'detail' : 'list',
    };
}
